import React from 'react'
import { Box, capitalize, Typography } from '@mui/material'


export default function frequencyColumn() {
	return {
		name: "idFrequencyWhenTranslation", label: "Frequency",
		options: {
			filter: false,
			customBodyRowRenderLite: (value, rowData) => <FrequencyCell value={value} rowData={rowData}/>
		}
	}
}

function FrequencyCell({ value }) {
	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
		{value.map(freq => <Typography key={freq}>
			{capitalize(freq)}
		</Typography>)}
	</Box>
}